export const STUDENT_ROUTE = "/student";
export const ADMIN_ROUTE = "/admin";
export const LAST_DASHBOARD_KEY = "lastDashboard";
